import {
  collection,
  deleteDoc,
  doc,
  getDocs,
  query,
  where,
} from "firebase/firestore";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { db, fAuth, firebaseApp, storage } from "../config/firebase";
import { v4 } from "uuid";
import { deleteUser } from "firebase/auth";
import { httpsCallable, getFunctions } from "firebase/functions";

let CONTENTS = "contents";
let LIFESTYLE = "lifestyle";
let COUPONS = "coupons";
let AOI = "area_of_interests";
let USERS = "users";
let C_SUITE_USERS = "c_suite_users";
let ANNOUNCEMENTS = "announcements";
let TOKENS = "user_tokens";
let DESIGNATIONS = "designations";
let KEYS = "keys";

const TEST = "_test";

// if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
//   CONTENTS = CONTENTS + TEST;
//   LIFESTYLE = LIFESTYLE + TEST;
//   COUPONS = COUPONS + TEST;
//   USERS = USERS + TEST;
//   C_SUITE_USERS = C_SUITE_USERS + TEST;
//   ANNOUNCEMENTS = ANNOUNCEMENTS + TEST;
//   TOKENS = TOKENS + TEST;
//   DESIGNATIONS = DESIGNATIONS + TEST;
// }

export const getUserNotificationCollection = (id) => {
  return `${USERS}/${id}/notifications`;
};

export const contentsCollectionRef = collection(db, CONTENTS);
export const lifestyleCollectionRef = collection(db, LIFESTYLE);
export const couponsCollectionRef = collection(db, COUPONS);
export const aoiCollectionRef = collection(db, AOI);
export const userCollectionRef = collection(db, USERS);
export const cSuiteCollectionRef = collection(db, C_SUITE_USERS);
export const announcementsRef = collection(db, ANNOUNCEMENTS);
export const tokensCollectionRef = collection(db, TOKENS);
export const designationsCollectionRef = collection(db, DESIGNATIONS);
export const keysCollectionRef = collection(db, KEYS);

const getDoc = (type, id) => doc(db, type, id);

export const getContentDoc = (id) => getDoc(CONTENTS, id);
export const getLifestyleDoc = (id) => getDoc(LIFESTYLE, id);
export const getAoiDoc = (id) => getDoc(AOI, id);
export const getCouponsDoc = (id) => getDoc(COUPONS, id);
export const getCSuitDoc = (id) => getDoc(C_SUITE_USERS, id);
export const getUserDoc = (id) => getDoc(USERS, id);
export const getAnnouncementDoc = (id) => getDoc(ANNOUNCEMENTS, id);
export const getDesignationDoc = (id) => getDoc(DESIGNATIONS, id);
export const getKeysDoc = (id) => getDoc(KEYS, id);

// export const getAuthenticatedUsers = () => fAuth.getUsers();

const contentStoragePath = `${CONTENTS}/`;
const lifeStyleStoragePath = `${LIFESTYLE}/`;
const couponStoragePath = `${COUPONS}/`;
const announcementStoragePath = `${ANNOUNCEMENTS}/`;

const imageRef = async (path, file) => {
  const location = path + v4() + file.name;
  const imageRef = ref(storage, location);
  await uploadBytes(imageRef, file);
  return await getDownloadURL(imageRef);
};

export const uploadImgContent = async (file) =>
  await imageRef(contentStoragePath, file);
export const uploadImgLifestyle = async (file) =>
  await imageRef(lifeStyleStoragePath, file);
export const uploadImgCoupon = async (file) =>
  await imageRef(couponStoragePath, file);
export const uploadImgAnnouncemnt = async (file) =>
  await imageRef(announcementStoragePath, file);

export const checkUserExist = async (email) => {
  // const c = query(
  //   cSuiteCollectionRef,
  //   where("email", "==", email),
  //   where("status", "==", "Created")
  // );
  // const c_data = await getDocs(c);

  // return {error : true, msg: "User is already created. Send invitation mail now."}

  const q = query(
    userCollectionRef,
    where("email", "==", email)
    // where("deleted", "==", false)
  );
  const data = await getDocs(q);
  let found = false;

  // console.log("data : ", data);
  if (data.docs.length) {
    data.docs.forEach((u, ind) => {
      if (u.data().deleted === undefined || false) {
        found = true;
      }
    });
  }
  return { error: found, msg: "Email already exist" };
};

export const checkIfProvidedEmailHadAdminAccess = async (email) => {
  const q = query(
    keysCollectionRef,
    where("admin_emails", "array-contains", email)
  );
  const data = await getDocs(q);
  return data?.docs?.length > 0 ? true : false;
};

export const getAdminEmail = async () => {
  const q = query(keysCollectionRef, where("admin_emails", "!=", null));
  const data = await getDocs(q);
  let firstDocData = data?.docs?.length ? data?.docs?.at(0)?.data() : {};
  return firstDocData?.admin_emails ? firstDocData?.admin_emails[0] : null;
};

export const checkIfUserExistsAndJoined = async (email) => {
  const q = query(
    userCollectionRef,
    where("email", "==", email)
    // where("new_user", "==", true)
  );
  const data = await getDocs(q);
  let found = false;

  if (data.docs.length) {
    let userData = data.docs.filter(
      (u) =>
        (u.data().deleted === undefined || u.data().deleted === false) &&
        u.data().status === "Joined"
    );
    if (userData.length) {
      found = true;
    }
  }
  return { error: found, msg: "Email already exist" };
};

// Function to get Firebase Auth users
export const getFirebaseUsers = async () => {
  try {
    let functions = getFunctions(firebaseApp);
    const listUsersFunction = httpsCallable(functions, "getVerifiedUsersList");
    console.log("calling getFirebaseUsers function !");
    const listUsersResult = await listUsersFunction();
    console.log("finished calling getFirebaseUsers function !");
    return listUsersResult.verifiedUserIds;
  } catch (error) {
    console.error("Error fetching users:", error);
    return [];
  }
};
